var exports = {
  "kL": "xa15a2ab7--855ab5--container",
  "kb": "xa15a2ab7--855ab5--left",
  "Qq": "xa15a2ab7--855ab5--text",
  "o1": "xa15a2ab7--855ab5--actions",
  "pG": "xa15a2ab7--855ab5--right",
};

module.exports = exports;
